module.exports = __webpack_public_path__ + "img/formulary.6544eb32.png";